/* eslint-disable camelcase */
import 'animate.css';

import { Grid } from '@mui/material';
import { RoutalPalette, VSpacer } from '@nx-smartmonkey/ui';

import DegradedBg from '../../../assets/img/onboarding/backgrounds/background-degraded-green.png';
import routalStar from '../../../assets/img/routal-star.svg';
import LogoRoutal from '../../../assets/svg/LogoRoutal';
import Button from '../../../react-components/Button';
import Text from '../../../react-components/Text';
import { OnboardingContent } from '../Onboarding.styled';

interface StartProps {
  onNextStep: () => void;
}

export const Start = ({ onNextStep }: StartProps) => {
  const startOnboarding = () => {
    const element = document.getElementById(`startOnboardingAnimatedContainer`);
    if (element) {
      element.classList.remove(`animate__fadeInUp`);
      element.classList.add(`animate__fadeOutUp`);
      setTimeout(() => {
        onNextStep();
      }, 500);
    } else {
      onNextStep();
    }
  };

  return (
    <OnboardingContent
      container
      direction="column"
      justifyContent="center"
      alignItems="center"
      wrap="nowrap"
      style={{
        width: `100vw`,
        height: `100vh`,
        backgroundImage: `url(${DegradedBg})`,
        backgroundSize: `cover`,
      }}
      className="animate__animated animate__fadeIn"
    >
      <Grid
        id="startOnboardingAnimatedContainer"
        item
        container
        direction="column"
        justifyContent="center"
        alignItems="center"
        className="animate__animated animate__fadeInUp"
      >
        <Grid item style={{ display: `flex`, alignItems: `center` }}>
          <LogoRoutal style={{ color: RoutalPalette.neutral00, height: `40px`, width: `213px` }} />
          <img src={routalStar} style={{ width: `21px`, height: `21px` }} alt="" />
        </Grid>

        <VSpacer large />

        <Grid item style={{ maxWidth: `800px` }}>
          <Text style={{ textAlign: `center`, color: `white` }} variant="h5" intlId="company.onboarding.start.text" />
        </Grid>

        <VSpacer large />

        <Grid item>
          <Button
            intlId="company.onboarding.start.button"
            styleType="secondary"
            style={{
              width: `200px`,
              height: `32px`,
            }}
            onClick={() => {
              startOnboarding();
            }}
          />
        </Grid>
      </Grid>
    </OnboardingContent>
  );
};
